/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SkuUnitPriceRequest {
    getFixupPrototypeFunction() { return SkuUnitPriceRequest.fixupPrototype; }

    static newInstance(model: Partial<SkuUnitPriceRequest>): SkuUnitPriceRequest {
        let obj = Object.assign(new SkuUnitPriceRequest(), model);
        SkuUnitPriceRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SkuUnitPriceRequest>): SkuUnitPriceRequest {
        if (!model) return null;
        return SkuUnitPriceRequest.newInstance(<SkuUnitPriceRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SkuUnitPriceRequest) {
        if (!obj) return;

        models.SkuUnitPriceRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SkuUnitPriceRequest): boolean {
        Object.setPrototypeOf(obj, SkuUnitPriceRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud provider. aws | azure
     */
    cloud_provider: string;

    /**
     * Service name. ec2 | rds | eks | elasticache | redshift
     */
    service: string;

    /**
     * Instance or node type e.g. m5.xlarge, db.m6i.32xlarge
     */
    sku_name: string;

    /**
     * AWS region code e.g. us-east-1
     */
    region: string;

    /**
     * ON_DEMAND | RESERVED
     */
    pricing_type: string;

    /**
     * 1yr | 3yr — RESERVED only
     */
    commitment_term: string;

    /**
     * NO_UPFRONT | PARTIAL_UPFRONT | ALL_UPFRONT — RESERVED only
     */
    payment_option: string;

    /**
     * Service-specific filter fields: os, db_engine, deployment, cache_engine
     */
    attributes: any;

}
